import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "qrcodewrap",
  id: "qrcodewrap"
};
const _hoisted_2 = {
  class: "qrcode",
  ref: "qrcode",
  style: {
    "display": "none"
  }
};
const _hoisted_3 = {
  class: "qrcode"
};
const _hoisted_4 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, null, 512), _createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: $data.Qrcimg,
    alt: ""
  }, null, 8, _hoisted_4)])]);
}